/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Layout, TextStyle, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { CaretDownMinor, CaretUpMinor } from '@shopify/polaris-icons';

import YoutubeModal from 'src/components/views/common/youtube-modal';

import { ARTICLE4 } from 'src/constants/onboarding';
import { URL } from 'src/constants/links';
import history from 'src/routes/history';

type Props = {};

type ComposedProps = Props & WithI18nProps;

type State = {
  current: number,
  youtubeModal: Object
};

class OnboardingArticles extends Component<ComposedProps, State> {
  state = {
    current: 0,
    youtubeModal: null
  };

  render() {
    const { i18n } = this.props;
    const { current, youtubeModal } = this.state;

    return (
      <div className="BC-Article4__Content">
        <Layout>
          <Layout.Section oneThird>
            {_.map(ARTICLE4, (item, index) => (
              <div className="article-content" key={index}>
                <div className={`list-feature ${current === index ? 'current' : 'not-current'}`}>
                  <Button
                    icon={current === index ? CaretDownMinor : CaretUpMinor}
                    plain
                    onClick={() => this.toggleContent(index)}
                  />
                  <div>
                    <p className="title">
                      <TextStyle variation="strong">{i18n.translate(item.title)}</TextStyle>
                    </p>
                    {current === index && (
                      <React.Fragment>
                        <p style={{ marginTop: '8px' }}>
                          <TextStyle>{i18n.translate(item.description)}</TextStyle>
                        </p>
                        <div style={{ marginTop: '8px' }}>
                          <Button primary onClick={() => {
                            history.push(item.action);
                          }}>
                            <TextStyle>{i18n.translate(item.button)}</TextStyle>
                          </Button>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
                {current === index && (
                  <div className="BC-Article-Video__Wrapper">
                    <div className="BC-Article-Video__Container">
                      <img
                        data-url={item.video}
                        data-title={i18n.translate(item.title)}
                        src={item.thumbnail}
                        alt={i18n.translate(item.title)}
                        onClick={this.openVideo}
                      />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </Layout.Section>
          <Layout.Section>
            <div className="BC-Article-Video__Wrapper">
              <div className="BC-Article-Video__Container">
                <img
                  data-url={ARTICLE4[current].video}
                  data-title={i18n.translate(ARTICLE4[current].title)}
                  src={ARTICLE4[current].thumbnail}
                  alt={i18n.translate(ARTICLE4[current].title)}
                  onClick={this.openVideo}
                />
              </div>
            </div>
          </Layout.Section>
        </Layout>
        <YoutubeModal
          active={youtubeModal !== null}
          {...youtubeModal}
          onClose={this.handleCloseYoutubeModal}
        />
      </div>
    );
  }

  toggleContent = (index: number) => {
    this.setState({ current: index });
  };

  openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');
  };

  openVideo = e => {
    const { url, title } = e.currentTarget.dataset;
    // Open video modal
    this.setState({
      youtubeModal: { embeddedURL: url, title }
    });
  };

  handleCloseYoutubeModal = () => this.setState({ youtubeModal: null });
}

export default withI18n()(OnboardingArticles);
